import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const componentsGenericBlockItem: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/components-generic-block-item`),
};

export default componentsGenericBlockItem;
